// extracted by mini-css-extract-plugin
var _1 = "AboutSettings_button__-aAv3";
var _2 = "AboutSettings_demoMode__LeJlf";
var _3 = "AboutSettings_icon__g2FyU";
var _4 = "AboutSettings_link__Nw7b4";
var _5 = "AboutSettings_links__d6vT1";
var _6 = "AboutSettings_logo__Wmzni";
var _7 = "AboutSettings_version__wQEb5";
export { _1 as "button", _2 as "demoMode", _3 as "icon", _4 as "link", _5 as "links", _6 as "logo", _7 as "version" }
